import moment from 'moment';
import { MONITORING_SET_CURRENT_PERIOD, MONITORING_SET_IS_FORM_OPEN, MONITORING_SET_IS_NAVIGATION_OPEN, MONITORING_SET_TOTAL_ANOMALY_DISPLAY_OPTIONS } from 'Redux/actionTypes';
import { TotalAnomalyDisplayOptionsEnum } from 'Monitoring/subPanels/constants';
import { PERIOD_SELECTOR_MODES, TIMESPAN_OPTIONS } from 'Utils/constants';
import { makeRoundSelectedPeriod } from 'Utils/dates/helpers';
import { LocalStorageKeys } from 'Utils/localStorage';
// ------------------------------------
// Constants
// ------------------------------------
export const initialState = {
    currentPeriod: JSON.parse(localStorage.getItem(LocalStorageKeys.CURRENT_MONITORING_PERIOD)) ||
        makeRoundSelectedPeriod({
            startDate: moment.utc().subtract(7, 'days').toDate().toISOString(),
            endDate: moment.utc().toDate().toISOString(),
            nDays: 7,
            label: TIMESPAN_OPTIONS.SEVEN_DAYS,
            type: PERIOD_SELECTOR_MODES.SIMPLE
        }),
    isNavigationOpen: false,
    isFormOpen: false,
    totalAnomalyDisplayOptions: {
        [TotalAnomalyDisplayOptionsEnum.AreaExtremes]: {
            isEnabled: true,
            text: 'Extrema'
        },
        [TotalAnomalyDisplayOptionsEnum.SyncTooltips]: {
            isEnabled: false,
            text: 'Sync tooltips'
        },
        [TotalAnomalyDisplayOptionsEnum.ImputedData]: {
            isEnabled: true,
            text: 'Imputed data'
        }
    }
};
// ------------------------------------
// Selectors
// ------------------------------------
/**
 * Simple function that takes Redux Store object and returns
 * subset of data that represents redux business-logic module slice
 * Beneficial because it encapsulates knowledge of
 * where to find that particular subset
 * @function
 * @param {Object} state redux Store object
 * @returns {Object} subset of data
 */
export const monitoringModuleSelector = (state) => state.monitoringModule;
/**
 * Selector function that returns currently selected Period in the Monitoring tool if any
 * @param {Object} state
 * @returns {Object||Null} Current Period
 */
export const currentMonitoringPeriodSelector = (state) => monitoringModuleSelector(state).currentPeriod;
export const monitoringIsNavigationOpenSelector = (state) => monitoringModuleSelector(state).isNavigationOpen;
export const monitoringIsFormOpenSelector = (state) => monitoringModuleSelector(state).isFormOpen;
export const monitoringTotalAnomalyDisplayOptionsSelector = (state) => monitoringModuleSelector(state).totalAnomalyDisplayOptions;
export const monitoringIsTooltipsSyncEnabledSelector = (state) => monitoringTotalAnomalyDisplayOptionsSelector(state)[TotalAnomalyDisplayOptionsEnum.SyncTooltips]
    .isEnabled;
export const monitoringIsImputedDataEnabledSelector = (state) => monitoringTotalAnomalyDisplayOptionsSelector(state)[TotalAnomalyDisplayOptionsEnum.ImputedData]
    .isEnabled;
// ------------------------------------
// Reducer
// ------------------------------------
// eslint-disable-next-line
const monitoringReducer = (state = initialState, action) => {
    switch (action.type) {
        case MONITORING_SET_CURRENT_PERIOD:
            return {
                ...state,
                currentPeriod: action.payload
            };
        case MONITORING_SET_IS_NAVIGATION_OPEN:
            return {
                ...state,
                isNavigationOpen: action.payload
            };
        case MONITORING_SET_IS_FORM_OPEN:
            return {
                ...state,
                isFormOpen: action.payload
            };
        case MONITORING_SET_TOTAL_ANOMALY_DISPLAY_OPTIONS:
            return {
                ...state,
                totalAnomalyDisplayOptions: action.payload
            };
        default:
            return state;
    }
};
export default monitoringReducer;
